import { createAsyncThunk } from '@reduxjs/toolkit';

import { FilterService } from 'api';

import { asyncPayloadCreator } from 'utils';

import { ICreateFilterProps } from 'models';

export const createFilter = createAsyncThunk(
	'primaryMarket/createFilter',
	(data: ICreateFilterProps, { rejectWithValue }) =>
		asyncPayloadCreator(data, { rejectWithValue }, FilterService.create),
);
